<template>
  <v-container fluid>
    <!-- Header Section -->
    <v-row>
      <v-col cols="12">
        <v-card class="header-card" elevation="8">
          <div class="header-gradient">
            <v-card-title class="white--text d-flex align-center py-6">
              <v-avatar color="white" size="56" class="mr-4">
                <v-icon color="primary" size="32">mdi-file-send</v-icon>
              </v-avatar>
              <div>
                <h1 class="font-weight-bold">เงื่อนไขในการรับย้าย</h1>
                <p class="mb-0 mt-1 white--text text--darken-1">
                  ระบบจัดการเงื่อนไขสาขาวิชาสำหรับการรับย้ายบุคลากร
                </p>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                fab
                small
                color="white"
                class="mr-2"
                @click="showVideoDialog = true"
              >
                <v-icon color="red">mdi-play-circle</v-icon>
              </v-btn>
              <v-chip
                color="white"
                text-color="primary"
                class="font-weight-bold"
              >
                <v-icon left small>mdi-identifier</v-icon>
                {{ id_ref }}
              </v-chip>
            </v-card-title>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Main Content -->
    <v-row>
      <!-- Info Cards Section -->
      <v-col cols="12" lg="4">
        <!-- College Info Card -->
        <v-card class="info-card mb-4" elevation="4">
          <v-card-title class="info-card-header primary white--text py-3">
            <v-icon left color="white">mdi-school</v-icon>
            ข้อมูลสถานศึกษา
          </v-card-title>
          <v-card-text class="pa-4">
            <v-list dense class="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-domain</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>วิทยาลัย</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold text-wrap">
                    {{ colleges_user.college_name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-barcode</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>รหัสวิทยาลัย</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">
                    {{ colleges_user.college_code }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>ผู้ดำเนินการ</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">
                    {{ user.frist_name }} {{ user.last_name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>

        <!-- Period Info Card -->
        <v-card class="info-card mb-4" elevation="4">
          <v-card-title class="info-card-header teal white--text py-3">
            <v-icon left color="white">mdi-calendar-clock</v-icon>
            ข้อมูลรอบการดำเนินการ
          </v-card-title>
          <v-card-text class="pa-4">
            <v-list dense class="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="teal">mdi-counter</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>ครั้งที่</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">
                    {{ period_colleges.period_college_times }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="teal">mdi-calendar</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>ประจำปี</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">
                    {{ period_colleges.period_college_year }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="teal">mdi-calendar-today</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>วันที่ยื่นคำร้อง</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">
                    {{ date_today }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <!-- Period Dates Display -->
            <v-divider class="my-3"></v-divider>
            <div class="period-dates pa-3 rounded grey lighten-4">
              <div class="d-flex align-center mb-2">
                <v-icon small color="success" class="mr-2"
                  >mdi-calendar-start</v-icon
                >
                <span class="text-caption">เปิดรับยื่น:</span>
                <span class="font-weight-bold ml-auto">{{
                  formattedStartDate
                }}</span>
              </div>
              <div class="d-flex align-center mb-2">
                <v-icon small color="error" class="mr-2"
                  >mdi-calendar-end</v-icon
                >
                <span class="text-caption">ปิดรับยื่น:</span>
                <span class="font-weight-bold ml-auto error--text">{{
                  formattedCloseDateTime
                }}</span>
              </div>
              <div class="d-flex align-center">
                <v-icon small color="info" class="mr-2">mdi-file-clock</v-icon>
                <span class="text-caption">ปิดรับแนบไฟล์:</span>
                <span class="font-weight-bold ml-auto info--text">{{
                  formattedFileCloseDateTime
                }}</span>
              </div>
            </div>

            <div>
              <div class="text-center font-weight-bold">
                สิ้นสุดการทำรายการ
              </div>
              <div class="countdown-timer">
                <flip-countdown
                  v-if="flipCountdownDeadline"
                  :deadline="flipCountdownDeadline"
                  :labels="labels"
                  class="countdown-timer"
                ></flip-countdown>
              </div>
            </div>

            <div>
              <div class="text-center font-weight-bold">
                แนบไฟล์สิ้นสุดวันที่
              </div>
              <div class="countdown-timer">
                <flip-countdown
                  v-if="flipCountdownDeadlineFile"
                  :deadline="flipCountdownDeadlineFile"
                  :labels="labels"
                  class="countdown-timer"
                ></flip-countdown>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Status Card -->
        <v-card class="status-card" elevation="4">
          <v-card-title class="py-3" :class="statusCardClass">
            <v-icon left color="white">{{ statusIcon }}</v-icon>
            <span class="white--text">{{ statusTitle }}</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-alert v-if="isSubmitted" type="success" text dense class="mb-3">
              <strong>บันทึกเงื่อนไขเรียบร้อยแล้ว</strong>
            </v-alert>
            <v-alert
              v-else-if="isPeriodClosed"
              type="error"
              text
              dense
              class="mb-3"
            >
              <strong>ปิดรับการยื่นเงื่อนไขแล้ว</strong>
            </v-alert>
            <v-alert v-else type="info" text dense class="mb-3">
              <strong>กำลังรอการบันทึกข้อมูล</strong>
            </v-alert>

            <!-- Branch Progress -->
            <div
              v-if="!isSubmitted && !isPeriodClosed"
              class="branch-progress mb-4"
            >
              <div class="d-flex justify-space-between align-center mb-2">
                <span class="text-caption">ความคืบหน้าการเพิ่มสาขาวิชา</span>
                <v-chip x-small :color="branchProgressColor" dark>
                  {{ conditions_branchs.length }}/{{ minBranchRequired }}
                </v-chip>
              </div>
              <v-progress-linear
                :value="branchProgress"
                :color="branchProgressColor"
                height="8"
                rounded
              ></v-progress-linear>
              <div class="text-caption mt-1" :class="branchProgressTextClass">
                {{ branchProgressText }}
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex flex-column">
              <v-btn
                v-if="isSubmitted && !isNeedless"
                color="primary"
                block
                class="mb-2"
                :href="printUrl"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon>
                พิมพ์แบบรายงาน
              </v-btn>

              <v-btn
                v-if="hasAttachment"
                color="teal"
                dark
                block
                class="mb-2"
                @click="viewDocument(conditions_transfers.documentsLinkfile)"
              >
                <v-icon left>mdi-file-pdf-box</v-icon>
                ดูไฟล์แนบ
              </v-btn>

              <v-btn
                v-if="canCancelAttachment"
                color="warning"
                block
                class="mb-2"
                @click="cancelPDF"
              >
                <v-icon left>mdi-close-circle</v-icon>
                ยกเลิกไฟล์แนบ
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Main Form Section -->
      <v-col cols="12" lg="8">
        <v-card elevation="4" class="main-form-card">
          <!-- Tab Header -->
          <v-tabs
            v-model="activeTab"
            background-color="primary"
            dark
            grow
            show-arrows
          >
            <v-tab>
              <v-icon left>mdi-format-list-bulleted</v-icon>
              รายการสาขาวิชา
              <v-badge
                v-if="conditions_branchs.length > 0"
                :content="conditions_branchs.length"
                :color="
                  conditions_branchs.length >= minBranchRequired
                    ? 'success'
                    : 'warning'
                "
                inline
                class="ml-2"
              ></v-badge>
            </v-tab>
            <v-tab :disabled="!isSubmitted || !canUploadFile">
              <v-icon left>mdi-file-upload</v-icon>
              แนบไฟล์เอกสาร
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <!-- Tab 1: Branch List -->
            <v-tab-item>
              <v-card-text class="pa-6">
                <!-- Period Closed Alert -->
                <v-alert
                  v-if="isPeriodClosed"
                  type="error"
                  prominent
                  border="left"
                  class="mb-4"
                >
                  <v-row align="center">
                    <v-col class="grow">
                      <h3 class="text-h6">ปิดรับการยื่นเงื่อนไขการรับย้าย</h3>
                      <p class="mb-0">
                        ขณะนี้ไม่อยู่ในช่วงเวลาที่กำหนดสำหรับการยื่นเงื่อนไข
                      </p>
                      <p class="mb-0 mt-2">
                        <strong>ปิดรับเมื่อ:</strong>
                        {{ formattedCloseDateTime }}
                      </p>
                    </v-col>
                  </v-row>
                </v-alert>

                <!-- Branch Selection Section -->
                <template v-else>
                  <!-- Minimum Requirement Alert -->
                  <v-alert
                    v-if="
                      !isSubmitted &&
                        conditions_branchs.length < minBranchRequired
                    "
                    type="warning"
                    prominent
                    border="left"
                    class="mb-4"
                  >
                    <v-row align="center">
                      <v-col>
                        <div class="d-flex align-center">
                          <v-icon large class="mr-3">mdi-alert-circle</v-icon>
                          <div>
                            <h3 class="text-h6 font-weight-bold">
                              ⚠️ ต้องระบุสาขาวิชาอย่างน้อย
                              {{ minBranchRequired }} รายการ
                            </h3>
                            <p class="mb-0">
                              ขณะนี้มี {{ conditions_branchs.length }} รายการ
                              (ต้องเพิ่มอีก
                              {{
                                minBranchRequired - conditions_branchs.length
                              }}
                              รายการ)
                            </p>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- Success Alert when minimum met -->
                  <v-alert
                    v-if="
                      !isSubmitted &&
                        conditions_branchs.length >= minBranchRequired
                    "
                    type="success"
                    text
                    dense
                    class="mb-4"
                  >
                    <v-icon left small>mdi-check-circle</v-icon>
                    จำนวน ({{ conditions_branchs.length }}/{{
                      minBranchRequired
                    }}
                    รายการ) - สามารถเพิ่มได้สูงสุด {{ maxBranchAllowed }} รายการ
                  </v-alert>

                  <!-- Header with Add Button -->
                  <div class="d-flex justify-space-between align-center mb-4">
                    <div>
                      <h3 class="font-weight-bold">
                        <v-icon left color="primary">mdi-flag-variant</v-icon>
                        สาขาวิชาในการรับย้าย
                      </h3>
                      <p class="grey--text mb-0">
                        เลือกสาขาวิชาที่ต้องการรับย้าย
                        <span class="font-weight-bold error--text">
                          ({{ minBranchRequired }} รายการ, สูงสุด
                          {{ maxBranchAllowed }} รายการ)
                        </span>
                      </p>
                      <p class="mb-0 mt-1">
                        <v-chip small :color="branchProgressColor" dark>
                          รายการขณะนี้ {{ conditions_branchs.length }} รายการ
                        </v-chip>
                      </p>
                    </div>
                    <v-btn
                      v-if="!isSubmitted"
                      color="success"
                      @click="openBranchDialog"
                      :disabled="conditions_branchs.length >= maxBranchAllowed"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      เพิ่มสาขาวิชา
                    </v-btn>
                  </div>

                  <!-- Empty State -->
                  <v-card
                    v-if="conditions_branchs.length === 0"
                    outlined
                    class="empty-state pa-8 text-center"
                  >
                    <v-icon size="80" color="grey lighten-1"
                      >mdi-file-document-outline</v-icon
                    >
                    <h3 class="grey--text mt-4">ยังไม่มีรายการสาขาวิชา</h3>
                    <p class="grey--text">
                      กดปุ่ม "เพิ่มสาขาวิชา"
                      เพื่อเริ่มเลือกสาขาวิชาที่ต้องการรับย้าย
                    </p>
                    <p class="error--text font-weight-bold">
                      * ต้องเพิ่มอย่างน้อย {{ minBranchRequired }} รายการ
                      จึงจะสามารถบันทึกได้
                    </p>
                    <v-btn
                      v-if="!isSubmitted"
                      color="success"
                      class="mt-4"
                      @click="openBranchDialog"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      เพิ่มสาขาวิชา
                    </v-btn>
                  </v-card>

                  <!-- Branch List Table -->
                  <v-data-table
                    v-else
                    :headers="branchTableHeaders"
                    :items="conditions_branchs"
                    :items-per-page="10"
                    class="elevation-1 branch-table"
                    hide-default-footer
                  >
                    <template v-slot:item.index="{ index }">
                      <v-chip small outlined color="primary">
                        {{ index + 1 }}
                      </v-chip>
                    </template>

                    <template v-slot:item.branch_info="{ item }">
                      <div>
                        <strong>{{ item.id_branch }}</strong> -
                        {{ item.name_branch }}
                        <div class="text-caption grey--text">
                          {{ item.name_sub_branch || "-" }}
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.quantity_n="{ item }">
                      <v-chip small outlined color="primary">
                        {{ item.quantity_n }} คน
                      </v-chip>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        v-if="!isSubmitted"
                        icon
                        color="error"
                        small
                        @click="confirmDeleteBranch(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <span v-else class="grey--text text-caption">-</span>
                    </template>
                  </v-data-table>

                  <!-- Note -->
                  <v-alert
                    v-if="conditions_branchs.length > 0 && !isSubmitted"
                    type="info"
                    text
                    dense
                    class="mt-4"
                  >
                    <v-icon left small>mdi-information</v-icon>
                    ลำดับรายการ 1-{{ maxBranchAllowed }}
                    ไม่มีผลต่อการพิจารณาย้าย
                  </v-alert>

                  <!-- Submit Section -->
                  <v-divider class="my-6"></v-divider>

                  <div
                    v-if="!isSubmitted && conditions_branchs.length > 0"
                    class="text-center"
                  >
                    <!-- Warning if not enough branches -->
                    <v-alert
                      v-if="conditions_branchs.length < minBranchRequired"
                      type="error"
                      prominent
                      class="mb-4"
                    >
                      <v-row align="center">
                        <v-col>
                          <h3 class="text-h6 font-weight-bold">
                            ❌ ไม่สามารถบันทึกได้
                          </h3>
                          <p class="mb-0">
                            ต้องเพิ่มสาขาวิชาอีก
                            {{ minBranchRequired - conditions_branchs.length }}
                            รายการ (ขั้นต่ำ {{ minBranchRequired }} รายการ)
                          </p>
                        </v-col>
                      </v-row>
                    </v-alert>

                    <v-alert v-else type="warning" text class="mb-4">
                      <v-icon left>mdi-alert</v-icon>
                      <strong>คำเตือน:</strong> เมื่อกดบันทึกแล้ว
                      จะไม่สามารถแก้ไขข้อมูลได้
                    </v-alert>

                    <v-btn
                      x-large
                      color="success"
                      @click="showConfirmDialog = true"
                      :loading="isSubmitting"
                      :disabled="conditions_branchs.length < minBranchRequired"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      บันทึกและยืนยันข้อมูล
                    </v-btn>

                    <p
                      v-if="conditions_branchs.length < minBranchRequired"
                      class="mt-3 error--text"
                    >
                      * ปุ่มบันทึกจะเปิดใช้งานเมื่อเพิ่มครบ
                      {{ minBranchRequired }} รายการ
                    </p>
                  </div>

                  <div v-if="isSubmitted" class="text-center">
                    <v-alert type="success" prominent class="mb-4">
                      <v-row align="center">
                        <v-col class="grow">
                          <h3>บันทึกข้อมูลเรียบร้อยแล้ว</h3>
                          <p class="mb-0">
                            คุณสามารถพิมพ์แบบรายงานได้จากปุ่มด้านล่าง
                          </p>
                        </v-col>
                      </v-row>
                    </v-alert>
                    <v-btn
                      x-large
                      color="primary"
                      :href="printUrl"
                      target="_blank"
                    >
                      <v-icon left>mdi-printer</v-icon>
                      พิมพ์แบบรายงานเงื่อนไขสาขาวิชาเอก
                    </v-btn>
                  </div>
                </template>
              </v-card-text>
            </v-tab-item>

            <!-- Tab 2: File Upload -->
            <v-tab-item>
              <v-card-text class="pa-6">
                <h3 class="font-weight-bold mb-4">
                  <v-icon left color="primary">mdi-file-upload</v-icon>
                  แนบไฟล์เงื่อนไขสาขาวิชา
                </h3>
                <p class="grey--text mb-4">
                  แนบไฟล์เงื่อนไขสาขาวิชาที่ได้รับการลงลายมือชื่อรับรองแล้ว
                  (เฉพาะไฟล์ PDF ขนาดไม่เกิน 5MB)
                </p>

                <!-- File Upload Deadline Info -->
                <v-alert type="info" text class="mb-4">
                  <div class="d-flex align-center">
                    <v-icon left>mdi-clock-outline</v-icon>
                    <span>
                      <strong>กำหนดปิดรับแนบไฟล์:</strong>
                      {{ formattedFileCloseDateTime }}
                    </span>
                  </div>
                </v-alert>

                <v-form ref="uploadForm" lazy-validation>
                  <v-file-input
                    v-model="documentsLinkfiles"
                    accept=".pdf"
                    color="primary"
                    counter
                    label="เลือกไฟล์ PDF"
                    placeholder="คลิกเพื่อเลือกไฟล์"
                    prepend-icon="mdi-paperclip"
                    outlined
                    :show-size="1000"
                    :rules="fileRules"
                    :disabled="hasAttachment"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip color="primary" dark label small>
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>

                  <v-btn
                    v-if="!hasAttachment"
                    color="success"
                    block
                    large
                    @click="uploadFileCondition"
                    :loading="isUploading"
                    :disabled="!documentsLinkfiles"
                  >
                    <v-icon left>mdi-cloud-upload</v-icon>
                    อัพโหลดไฟล์
                  </v-btn>

                  <v-alert v-if="hasAttachment" type="success" class="mt-4">
                    <v-row align="center">
                      <v-col class="grow">
                        <strong>อัพโหลดไฟล์เรียบร้อยแล้ว</strong>
                        <div class="text-caption">
                          {{ conditions_transfers.documentsLinkfile }}
                        </div>
                      </v-col>
                      <v-col class="shrink">
                        <v-btn
                          small
                          color="white"
                          @click="
                            viewDocument(conditions_transfers.documentsLinkfile)
                          "
                        >
                          <v-icon left small>mdi-eye</v-icon>
                          ดูไฟล์
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-form>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <!-- ==================== DIALOGS ==================== -->

    <!-- Add Branch Dialog -->
    <v-dialog
      v-model="showBranchDialog"
      max-width="900px"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          เพิ่มสาขาวิชา
          <v-spacer></v-spacer>
          <v-chip small color="white" text-color="primary" class="mr-4">
            {{ conditions_branchs.length }}/{{ maxBranchAllowed }} รายการ
          </v-chip>
          <v-btn icon dark @click="showBranchDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <!-- Remaining Alert -->
          <v-alert
            v-if="conditions_branchs.length < minBranchRequired"
            type="warning"
            dense
            text
            class="mb-4"
          >
            <v-icon left small>mdi-alert</v-icon>
            ต้องเพิ่มอีก
            {{ minBranchRequired - conditions_branchs.length }} รายการ (ขั้นต่ำ
            {{ minBranchRequired }} รายการ)
          </v-alert>

          <v-form ref="addBranchForm" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="newBranch.id_branch"
                  :items="branch_s"
                  item-text="name_branch"
                  item-value="id_branch"
                  label="สาขาวิชาเอก *"
                  outlined
                  prepend-inner-icon="mdi-source-commit"
                  :rules="[v => !!v || 'กรุณาเลือกสาขาวิชาเอก']"
                  @change="onBranchChange"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{
                        item.name_branch
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        >รหัส: {{ item.id_branch }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="newBranch.con_id_branch_sub"
                  :items="branch_sub_ds"
                  item-text="name_sub_branch"
                  item-value="id_branch_sub"
                  label="สาขางาน (ระบุหรือไม่ก็ได้)"
                  outlined
                  prepend-inner-icon="mdi-source-branch"
                  clearable
                  :disabled="!newBranch.id_branch"
                  :loading="isLoadingSubBranch"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="newBranch.quantity_n"
                  type="number"
                  label="จำนวนที่ต้องการรับ *"
                  outlined
                  prepend-inner-icon="mdi-account-multiple-plus"
                  :rules="[
                    v => !!v || 'กรุณาระบุจำนวน',
                    v => v > 0 || 'จำนวนต้องมากกว่า 0',
                    v => v <= 100 || 'จำนวนต้องไม่เกิน 100'
                  ]"
                  min="1"
                  max="100"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="8">
                <v-text-field
                  v-model="newBranch.con_datail_branch"
                  label="คุณลักษณะเพิ่มเติม"
                  outlined
                  prepend-inner-icon="mdi-text"
                  placeholder="ระบุหรือไม่ก็ได้"
                  counter="200"
                  maxlength="200"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Required Fields Note -->
            <v-alert type="info" text dense>
              <v-icon left small>mdi-information</v-icon>
              <strong>*</strong> หมายถึงช่องที่ต้องกรอก
            </v-alert>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="showBranchDialog = false">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="success"
            @click="submitNewBranch"
            :loading="isSavingBranch"
          >
            <v-icon left>mdi-content-save</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Branch Confirmation Dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-delete-alert</v-icon>
          ยืนยันการลบ
        </v-card-title>
        <v-card-text class="pa-6">
          <v-alert type="warning" text>
            คุณต้องการลบรายการสาขาวิชานี้หรือไม่?
          </v-alert>
          <div v-if="branchToDelete" class="mt-4">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle>สาขาวิชา</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold">
                  {{ branchToDelete.name_branch }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle>สาขางาน</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold">
                  {{ branchToDelete.name_sub_branch || "-" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle>จำนวนรับ</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold">
                  {{ branchToDelete.quantity_n }} คน
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>

          <!-- Warning if deleting would go below minimum -->
          <v-alert
            v-if="conditions_branchs.length <= minBranchRequired"
            type="error"
            text
            dense
            class="mt-4"
          >
            <v-icon left small>mdi-alert</v-icon>
            หากลบรายการนี้ จะเหลือไม่ถึง {{ minBranchRequired }} รายการ
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="showDeleteDialog = false">ยกเลิก</v-btn>
          <v-btn color="error" @click="deleteBranch" :loading="isDeleting">
            <v-icon left>mdi-delete</v-icon>
            ลบรายการ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirm Submit Dialog -->
    <v-dialog v-model="showConfirmDialog" max-width="550px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-alert-circle</v-icon>
          ยืนยันการบันทึก
        </v-card-title>
        <v-card-text class="pa-6">
          <v-alert type="error" prominent border="left">
            <h3 class="text-subtitle-1 font-weight-bold mb-2">คำเตือนสำคัญ</h3>
            <p class="mb-0">
              หากกดปุ่มยืนยัน ท่านจะ<strong
                >ไม่สามารถแก้ไขข้อมูลใดๆ ได้อีก</strong
              >
              กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนยืนยัน
            </p>
          </v-alert>

          <!-- Summary -->
          <v-card outlined class="mt-4">
            <v-card-text>
              <h4 class="font-weight-bold mb-3">สรุปข้อมูล</h4>
              <div class="d-flex justify-space-between mb-2">
                <span>จำนวนสาขาวิชาที่เลือก:</span>
                <v-chip small color="success" dark>
                  {{ conditions_branchs.length }} รายการ
                </v-chip>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="text-caption grey--text">
                รายการสาขาวิชา:
              </div>
              <ul class="mt-2">
                <li
                  v-for="(branch, index) in conditions_branchs"
                  :key="index"
                  class="text-body-2"
                >
                  {{ branch.name_branch }} ({{ branch.quantity_n }} คน)
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="showConfirmDialog = false">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="success"
            @click="submitConditionsTransfer"
            :loading="isSubmitting"
          >
            <v-icon left>mdi-check</v-icon>
            ยืนยันบันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Cancel Condition Dialog -->
    <v-dialog v-model="showCancelConditionDialog" max-width="550px" persistent>
      <v-card>
        <v-card-title class="orange darken-1 white--text">
          <v-icon left color="white">mdi-cancel</v-icon>
          ไม่ประสงค์รับย้าย
        </v-card-title>
        <v-card-text class="pa-6">
          <v-alert type="warning" text class="mb-4">
            กรุณาแนบไฟล์วาระการประชุมเพื่อยืนยันการไม่ประสงค์รับย้าย
          </v-alert>
          <v-form ref="cancelForm" lazy-validation>
            <v-file-input
              v-model="cancelDocumentFile"
              accept=".pdf"
              color="orange darken-1"
              counter
              label="ไฟล์วาระการประชุม (PDF)"
              placeholder="เลือกไฟล์ PDF"
              prepend-icon="mdi-paperclip"
              outlined
              :show-size="1000"
              :rules="[
                v => !!v || 'กรุณาเลือกไฟล์',
                v => !v || v.size < 5242880 || 'ไฟล์ต้องมีขนาดไม่เกิน 5MB'
              ]"
            ></v-file-input>
          </v-form>
          <v-alert type="error" text dense>
            <strong>หมายเหตุ:</strong> เมื่อยืนยันแล้วจะไม่สามารถแก้ไขได้
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="showCancelConditionDialog = false">ยกเลิก</v-btn>
          <v-btn
            color="orange darken-1"
            dark
            @click="submitCancelCondition"
            :loading="isCancelling"
          >
            <v-icon left>mdi-check</v-icon>
            ยืนยัน
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PDF Viewer Dialog -->
    <v-dialog v-model="showPdfDialog" max-width="900px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-file-pdf-box</v-icon>
          ดูเอกสาร PDF
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showPdfDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <embed
            :src="'/HRvecfiles/' + currentPdfFile"
            width="100%"
            height="600px"
            type="application/pdf"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Video Dialog -->
    <v-dialog v-model="showVideoDialog" max-width="900px">
      <v-card>
        <v-card-title class="red white--text">
          <v-icon left color="white">mdi-video</v-icon>
          วิดีโอแนะนำการใช้งาน
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeVideoDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <div class="video-container">
            <iframe
              v-if="showVideoDialog"
              width="100%"
              height="500"
              :src="videoUrl"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notification -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Loading Overlay -->
    <v-overlay :value="isLoading" z-index="999">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
      <p class="white--text mt-4">กำลังโหลดข้อมูล...</p>
    </v-overlay>
  </v-container>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";
export default {
  name: "ConditionsTransfer",
  components: { FlipCountdown },
  data() {
    return {
      // API Key
      ApiKey: "HRvec2021",

      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },

      // Configuration - Minimum/Maximum branches
      minBranchRequired: 1,
      maxBranchAllowed: 10,

      // Loading States
      isLoading: true,
      isSubmitting: false,
      isSavingBranch: false,
      isDeleting: false,
      isUploading: false,
      isCancelling: false,
      isLoadingSubBranch: false,

      // Tab
      activeTab: 0,

      // Dialog States
      showBranchDialog: false,
      showDeleteDialog: false,
      showConfirmDialog: false,
      showCancelConditionDialog: false,
      showPdfDialog: false,
      showVideoDialog: false,

      // Data
      colleges_user: {},
      user: {},
      period_colleges: {},
      period_collegeFiles: {},
      conditions_transfers: {},
      conditions_branchs: [],
      branch_s: [],
      branch_sub_ds: [],

      // Countdown
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      fileCountdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },

      // Form Data
      newBranch: {
        id_branch: null,
        con_id_branch_sub: null,
        quantity_n: null,
        educational_level: null,
        con_datail_branch: ""
      },
      branchToDelete: null,
      documentsLinkfiles: null,
      cancelDocumentFile: null,
      currentPdfFile: "",

      // Options
      educationLevels: [
        { title: "ปริญญาตรี" },
        { title: "ปริญญาโท" },
        { title: "ปริญญาเอก" }
      ],

      // Table Headers
      branchTableHeaders: [
        { text: "สาขาวิชา/สาขางาน", value: "branch_info", sortable: false },
        {
          text: "จำนวนรับ",
          value: "quantity_n",
          align: "center",
          width: "120px"
        },
        {
          text: "ดำเนินการ",
          value: "actions",
          align: "center",
          width: "100px",
          sortable: false
        }
      ],

      // File Rules
      fileRules: [v => !v || v.size < 5242880 || "ไฟล์ต้องมีขนาดไม่เกิน 5MB"],

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      },

      // Timers
      checkInterval: null,
      countdownInterval: null
    };
  },

  computed: {
    flipCountdownDeadline() {
      if (!this.period_colleges.period_college_stop) {
        return null;
      }
      // Ensures a valid date string format YYYY-MM-DD HH:MM:SS
      return `${this.period_colleges.period_college_stop} 16:30:00`;
    },

    flipCountdownDeadlineFile() {
      if (!this.period_collegeFiles.period_college_stop) {
        return null;
      }
      // Ensures a valid date string format YYYY-MM-DD HH:MM:SS
      return `${this.period_collegeFiles.period_college_stop} 16:30:00`;
    },

    // Generate Reference ID
    id_ref() {
      if (
        !this.period_collegeFiles.period_college_times ||
        !this.colleges_user.user_name
      ) {
        return "";
      }
      return `${this.period_collegeFiles.period_college_times}${this.period_collegeFiles.period_college_year}${this.colleges_user.user_name}`;
    },

    // Format Today's Date in Thai
    date_today() {
      const monthNames = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear() + 543;
      return `${dd} ${monthNames[mm]} ${yyyy}`;
    },

    // Formatted Close DateTime
    formattedCloseDateTime() {
      if (!this.period_colleges.period_college_stop) return "-";
      return this.formatThaiDateTime(
        this.period_colleges.period_college_stop,
        "16:30"
      );
    },

    // Formatted File Close DateTime
    formattedFileCloseDateTime() {
      if (!this.period_colleges.period_college_attactmentstop) return "-";
      return this.formatThaiDateTime(
        this.period_colleges.period_college_attactmentstop,
        "16:30"
      );
    },

    // Formatted Start Date
    formattedStartDate() {
      if (!this.period_colleges.period_college_start) return "-";
      return this.formatThaiDateTime(
        this.period_colleges.period_college_start,
        "08:30"
      );
    },

    // Check if period is open
    isPeriodOpen() {
      return (
        this.period_colleges.period_college_enable === "1" &&
        this.period_colleges.period_college_type === "movement_college"
      );
    },

    // Check if period is closed
    isPeriodClosed() {
      return !this.isPeriodOpen;
    },

    // Check if already submitted
    isSubmitted() {
      return this.conditions_transfers.id_ref === this.id_ref;
    },

    // Check if status is needless
    isNeedless() {
      return this.conditions_transfers.status_confirm === "needless";
    },

    // Check if has attachment
    hasAttachment() {
      return !!this.conditions_transfers.documentsLinkfile;
    },

    // Check if can cancel attachment
    canCancelAttachment() {
      return (
        this.hasAttachment &&
        this.conditions_transfers.status_confirm !== "cc" &&
        !this.isNeedless
      );
    },

    // Check if can upload file
    canUploadFile() {
      return this.period_collegeFiles.period_college_enable_file === "1";
    },

    // Print URL
    printUrl() {
      return `#/college/print_condition/?id_ref=${this.id_ref}`;
    },

    // Video URL
    videoUrl() {
      return this.showVideoDialog
        ? "https://www.youtube.com/embed/iVZy90tWSZg"
        : "";
    },

    // Status Card Class
    statusCardClass() {
      if (this.isSubmitted && !this.isNeedless) return "success";
      if (this.isNeedless) return "orange darken-1";
      if (this.isPeriodClosed) return "error";
      return "info";
    },

    // Status Icon
    statusIcon() {
      if (this.isSubmitted && !this.isNeedless) return "mdi-check-circle";
      if (this.isNeedless) return "mdi-cancel";
      if (this.isPeriodClosed) return "mdi-close-circle";
      return "mdi-clock-outline";
    },

    // Status Title
    statusTitle() {
      if (this.isSubmitted && !this.isNeedless) return "บันทึกเรียบร้อย";
      if (this.isNeedless) return "ไม่ประสงค์รับย้าย";
      if (this.isPeriodClosed) return "ปิดรับการยื่น";
      return "รอดำเนินการ";
    },

    // Branch Progress (percentage)
    branchProgress() {
      return Math.min(
        (this.conditions_branchs.length / this.minBranchRequired) * 100,
        100
      );
    },

    // Branch Progress Color
    branchProgressColor() {
      if (this.conditions_branchs.length >= this.minBranchRequired)
        return "success";
      if (this.conditions_branchs.length >= 2) return "warning";
      return "error";
    },

    // Branch Progress Text
    branchProgressText() {
      if (this.conditions_branchs.length >= this.minBranchRequired) {
        return `✓ ครบตามเกณฑ์ขั้นต่ำแล้ว (เพิ่มได้อีก ${this.maxBranchAllowed -
          this.conditions_branchs.length} รายการ)`;
      }
      return `ต้องเพิ่มอีก ${this.minBranchRequired -
        this.conditions_branchs.length} รายการ`;
    },

    // Branch Progress Text Class
    branchProgressTextClass() {
      if (this.conditions_branchs.length >= this.minBranchRequired)
        return "success--text";
      return "error--text";
    },

    // Countdown Alert Type
    countdownAlertType() {
      const totalSeconds =
        this.countdown.days * 86400 +
        this.countdown.hours * 3600 +
        this.countdown.minutes * 60 +
        this.countdown.seconds;

      if (totalSeconds <= 3600) return "error"; // Less than 1 hour
      if (totalSeconds <= 86400) return "warning"; // Less than 1 day
      return "info";
    }
  },

  async mounted() {
    await this.initializeData();
  },

  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },

  methods: {
    // Format Thai DateTime
    formatThaiDateTime(dateStr, time = "16:30") {
      const monthNames = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];

      const parts = dateStr.split("-");
      const yyyy = parseInt(parts[0]) + 543;
      const mm = parseInt(parts[1]);
      const dd = parseInt(parts[2]);

      return `${dd} ${monthNames[mm]} ${yyyy} เวลา ${time} น.`;
    },

    // Initialize all data
    async initializeData() {
      this.isLoading = true;
      try {
        await this.fetchPeriodData();
        await this.fetchCollegeUser();
        await this.fetchBranches();
        await this.fetchConditionsTransfer();
        await this.fetchConditionsBranch();
        this.startTimeCheck();
        this.startCountdown();
      } catch (error) {
        this.showNotification(
          "error",
          "เกิดข้อผิดพลาดในการโหลดข้อมูล",
          "mdi-alert"
        );
        console.error("Initialize error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    // Start Countdown Timer
    startCountdown() {
      this.updateCountdown();
      this.countdownInterval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },

    // Update Countdown
    updateCountdown() {
      // Main countdown (submission deadline)
      if (this.period_colleges.period_college_stop) {
        const stopDate = new Date(
          this.period_colleges.period_college_stop + " 16:30:00"
        );
        const now = new Date();
        const diff = stopDate - now;

        if (diff > 0) {
          this.countdown.days = Math.floor(diff / (1000 * 60 * 60 * 24));
          this.countdown.hours = Math.floor(
            (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          this.countdown.minutes = Math.floor(
            (diff % (1000 * 60 * 60)) / (1000 * 60)
          );
          this.countdown.seconds = Math.floor((diff % (1000 * 60)) / 1000);
        } else {
          this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
      }

      // File upload countdown
      if (this.period_colleges.period_college_attactmentstop) {
        const fileStopDate = new Date(
          this.period_colleges.period_college_attactmentstop + " 16:30:00"
        );
        const now = new Date();
        const fileDiff = fileStopDate - now;

        if (fileDiff > 0) {
          this.fileCountdown.days = Math.floor(
            fileDiff / (1000 * 60 * 60 * 24)
          );
          this.fileCountdown.hours = Math.floor(
            (fileDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          this.fileCountdown.minutes = Math.floor(
            (fileDiff % (1000 * 60 * 60)) / (1000 * 60)
          );
          this.fileCountdown.seconds = Math.floor(
            (fileDiff % (1000 * 60)) / 1000
          );
        } else {
          this.fileCountdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
      }
    },

    // Fetch period data
    async fetchPeriodData() {
      const [periodResult, fileResult] = await Promise.all([
        this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable: "1",
          period_college_id: "401"
        }),
        this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_enable_file: "1",
          period_college_id: "401"
        })
      ]);

      this.period_colleges = periodResult.data;
      this.period_collegeFiles = fileResult.data;

      // Check if period is available
      if (
        this.period_colleges.period_college_enable !== "1" &&
        this.period_collegeFiles.period_college_enable_file !== "1"
      ) {
        await Swal.fire({
          icon: "error",
          title: "ยังไม่มีกำหนดการ",
          allowOutsideClick: false,
          allowEscapeKey: false
        });
        this.$router.push("/college");
      }
    },

    // Fetch college user data
    async fetchCollegeUser() {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      const result = await this.$http.post("admin.php", {
        ApiKey: this.ApiKey,
        user_name: userSession.user_name
      });
      this.colleges_user = result.data;
    },

    // Fetch branches
    async fetchBranches() {
      const result = await this.$http.post("branch.php", {
        ApiKey: this.ApiKey
      });
      this.branch_s = result.data;
    },

    // Fetch conditions transfer
    async fetchConditionsTransfer() {
      const result = await this.$http.post("conditions_transfer.php", {
        ApiKey: this.ApiKey,
        id_ref: this.id_ref
      });
      this.conditions_transfers = result.data || {};
    },

    // Fetch conditions branch
    async fetchConditionsBranch() {
      const result = await this.$http.post("conditions_branch.php", {
        ApiKey: this.ApiKey,
        id_ref: this.id_ref
      });
      this.conditions_branchs = result.data || [];
    },

    // Fetch sub branches
    async fetchSubBranches(id_branch) {
      this.isLoadingSubBranch = true;
      try {
        const result = await this.$http.post("branch_sub_d.php", {
          ApiKey: this.ApiKey,
          id_main_branch: id_branch
        });
        this.branch_sub_ds = result.data || [];
      } finally {
        this.isLoadingSubBranch = false;
      }
    },

    // Time check for period expiration
    startTimeCheck() {
      const dateNow = new Date().getTime();
      const dateStop = new Date(
        this.period_colleges.period_college_stop + " 16:30:00"
      ).getTime();
      const dateFileStop = new Date(
        this.period_colleges.period_college_attactmentstop + " 16:30:00"
      ).getTime();

      this.checkInterval = setInterval(async () => {
        const currentTime = new Date().getTime();

        if (
          currentTime > dateStop &&
          this.period_colleges.period_college_enable === "1"
        ) {
          await this.updatePeriodStatus("period_college_enable", "0");
        }

        if (
          currentTime > dateFileStop &&
          this.period_collegeFiles.period_college_enable_file === "1"
        ) {
          await this.updatePeriodStatus("period_college_enable_file", "0");
        }
      }, 30000); // Check every 30 seconds
    },

    // Update period status
    async updatePeriodStatus(field, value) {
      const updateData = {
        ApiKey: this.ApiKey,
        ...this.period_colleges,
        [field]: value
      };
      await this.$http.post("period_college.update.php", updateData);
      await this.fetchPeriodData();
    },

    // Open branch dialog
    openBranchDialog() {
      this.resetNewBranch();
      this.showBranchDialog = true;
    },

    // Reset new branch form
    resetNewBranch() {
      this.newBranch = {
        id_branch: null,
        con_id_branch_sub: null,
        quantity_n: null,
        educational_level: null,
        con_datail_branch: ""
      };
      this.branch_sub_ds = [];
      if (this.$refs.addBranchForm) {
        this.$refs.addBranchForm.resetValidation();
      }
    },

    // On branch change - fetch sub branches
    async onBranchChange(id_branch) {
      if (id_branch) {
        await this.fetchSubBranches(id_branch);
      } else {
        this.branch_sub_ds = [];
      }
      this.newBranch.con_id_branch_sub = null;
    },

    // Submit new branch
    async submitNewBranch() {
      if (!this.$refs.addBranchForm.validate()) return;

      // Check max branches
      if (this.conditions_branchs.length >= this.maxBranchAllowed) {
        this.showNotification(
          "warning",
          `ท่านได้ทำการบันทึกรายการครบ ${this.maxBranchAllowed} ลำดับแล้ว`,
          "mdi-alert"
        );
        return;
      }

      this.isSavingBranch = true;
      try {
        const result = await this.$http.post("conditions_branch.insert.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref,
          college_code: this.colleges_user.college_code,
          id_branch: this.newBranch.id_branch,
          con_id_branch_sub: this.newBranch.con_id_branch_sub,
          con_datail_branch: this.newBranch.con_datail_branch,
          educational_level: this.newBranch.educational_level,
          quantity_n: this.newBranch.quantity_n,
          condStatus: "save"
        });

        if (result.data.status === true) {
          this.showNotification(
            "success",
            "บันทึกข้อมูลเรียบร้อย",
            "mdi-check-circle"
          );
          await this.fetchConditionsBranch();

          // Check if minimum is met
          if (this.conditions_branchs.length >= this.minBranchRequired) {
            this.showNotification(
              "success",
              `ครบ ${this.minBranchRequired} รายการแล้ว สามารถบันทึกและยืนยันได้`,
              "mdi-check-circle"
            );
          }

          this.showBranchDialog = false;
        } else {
          this.showNotification(
            "error",
            "รายการซ้ำ กรุณาตรวจสอบสาขาวิชา",
            "mdi-alert"
          );
        }
      } catch (error) {
        this.showNotification(
          "error",
          "เกิดข้อผิดพลาด กรุณาลองใหม่",
          "mdi-alert"
        );
        console.error("Submit branch error:", error);
      } finally {
        this.isSavingBranch = false;
      }
    },

    // Confirm delete branch
    confirmDeleteBranch(item) {
      this.branchToDelete = item;
      this.showDeleteDialog = true;
    },

    // Delete branch
    async deleteBranch() {
      if (!this.branchToDelete) return;

      this.isDeleting = true;
      try {
        const result = await this.$http.post("conditions_branch.delete.php", {
          ApiKey: this.ApiKey,
          id_ref: this.branchToDelete.id_ref,
          id_branch: this.branchToDelete.id_branch,
          con_id_branch_sub: this.branchToDelete.con_id_branch_sub,
          educational_level: this.branchToDelete.educational_level
        });

        if (result.data.status === true) {
          this.showNotification(
            "success",
            "ลบรายการเรียบร้อย",
            "mdi-check-circle"
          );
          await this.fetchConditionsBranch();
        } else {
          this.showNotification("error", "เกิดข้อผิดพลาดในการลบ", "mdi-alert");
        }
      } catch (error) {
        this.showNotification(
          "error",
          "เกิดข้อผิดพลาด กรุณาลองใหม่",
          "mdi-alert"
        );
        console.error("Delete branch error:", error);
      } finally {
        this.isDeleting = false;
        this.showDeleteDialog = false;
        this.branchToDelete = null;
      }
    },

    // Submit conditions transfer
    async submitConditionsTransfer() {
      // Validate minimum branches
      if (this.conditions_branchs.length < this.minBranchRequired) {
        this.showNotification(
          "error",
          `ต้องเพิ่มสาขาวิชาอย่างน้อย ${this.minBranchRequired} รายการ`,
          "mdi-alert"
        );
        this.showConfirmDialog = false;
        return;
      }

      this.isSubmitting = true;
      try {
        const result = await this.$http.post("conditions_transfer.insert.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref,
          time_s: this.period_colleges.period_college_times,
          year_s: this.period_colleges.period_college_year,
          college_code: this.colleges_user.college_code,
          date_time: this.date_today
        });

        if (result.data.status === true) {
          await Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลเรียบร้อย",
            text: "ท่านสามารถพิมพ์แบบรายงานได้แล้ว",
            showConfirmButton: true
          });
          await this.fetchConditionsTransfer();
        } else {
          this.showNotification(
            "error",
            "เกิดข้อผิดพลาดในการบันทึก",
            "mdi-alert"
          );
        }
      } catch (error) {
        this.showNotification(
          "error",
          "เกิดข้อผิดพลาด กรุณาลองใหม่",
          "mdi-alert"
        );
        console.error("Submit transfer error:", error);
      } finally {
        this.isSubmitting = false;
        this.showConfirmDialog = false;
      }
    },

    // Upload file condition
    async uploadFileCondition() {
      if (!this.$refs.uploadForm.validate()) return;
      if (!this.documentsLinkfiles) {
        this.showNotification("warning", "กรุณาเลือกไฟล์", "mdi-alert");
        return;
      }

      this.isUploading = true;
      try {
        const filename = `${this.conditions_transfers.id_ref}condition.pdf`;
        const formData = new FormData();
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.documentsLinkfiles);
        formData.append("filename", `../HRvecfiles/${filename}`);

        const uploadResult = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        if (uploadResult.data.status === true) {
          const updateResult = await this.$http.post(
            "conditions_transfer.update.php",
            {
              ApiKey: this.ApiKey,
              id_ref: this.conditions_transfers.id_ref,
              documentsLinkfile: filename
            }
          );

          if (updateResult.data.status === true) {
            this.showNotification(
              "success",
              "อัพโหลดไฟล์เรียบร้อย",
              "mdi-check-circle"
            );
            await this.fetchConditionsTransfer();
            this.documentsLinkfiles = null;
          }
        } else {
          this.showNotification(
            "error",
            "เกิดข้อผิดพลาดในการอัพโหลด",
            "mdi-alert"
          );
        }
      } catch (error) {
        this.showNotification(
          "error",
          "เกิดข้อผิดพลาด กรุณาลองใหม่",
          "mdi-alert"
        );
        console.error("Upload error:", error);
      } finally {
        this.isUploading = false;
      }
    },

    // Cancel PDF
    async cancelPDF() {
      const result = await Swal.fire({
        title: "ยืนยันการยกเลิกไฟล์แนบ",
        text: "ต้องการยกเลิกไฟล์แนบเนื่องจากแนบไฟล์ผิดพลาด?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });

      if (result.isConfirmed) {
        try {
          const updateResult = await this.$http.post(
            "conditions_transfer.update.php",
            {
              ApiKey: this.ApiKey,
              id_ref: this.id_ref,
              status_confirm: "cc"
            }
          );

          if (updateResult.data.status === true) {
            // Send line notification
            await this.$http.post("linenotify_hr.php", {
              ApiKey: this.ApiKey,
              college_name: this.colleges_user.college_name,
              details: "งานย้าย : วิทยาลัยขอยกเลิกไฟล์แนบแจ้งเงื่อนไขสาขาวิชา",
              datetime: this.date_today
            });

            this.showNotification(
              "success",
              "ส่งคำขอยกเลิกเรียบร้อย รอการตรวจสอบจากส่วนกลาง",
              "mdi-check-circle"
            );
            await this.fetchConditionsTransfer();
          }
        } catch (error) {
          this.showNotification("error", "เกิดข้อผิดพลาด", "mdi-alert");
          console.error("Cancel PDF error:", error);
        }
      }
    },

    // Submit cancel condition
    async submitCancelCondition() {
      if (!this.$refs.cancelForm.validate()) return;

      this.isCancelling = true;
      try {
        const filename = `${this.id_ref}conditionCan.pdf`;
        const formData = new FormData();
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.cancelDocumentFile);
        formData.append("filename", `../HRvecfiles/${filename}`);

        const uploadResult = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        if (uploadResult.data.status === true) {
          const insertResult = await this.$http.post(
            "conditions_transfer.insert.php",
            {
              ApiKey: this.ApiKey,
              id_ref: this.id_ref,
              time_s: this.period_colleges.period_college_times,
              year_s: this.period_colleges.period_college_year,
              status_confirm: "needless",
              college_code: this.colleges_user.college_code,
              date_time: this.date_today,
              documentsLinkfile: filename
            }
          );

          if (insertResult.data.status === true) {
            await Swal.fire({
              icon: "success",
              title: "บันทึกข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            await this.fetchConditionsTransfer();
            await this.fetchConditionsBranch();
            this.showCancelConditionDialog = false;
            this.cancelDocumentFile = null;
          }
        } else {
          this.showNotification("error", "กรุณาแนบไฟล์ให้ถูกต้อง", "mdi-alert");
        }
      } catch (error) {
        this.showNotification("error", "เกิดข้อผิดพลาด", "mdi-alert");
        console.error("Cancel condition error:", error);
      } finally {
        this.isCancelling = false;
      }
    },

    // View document
    viewDocument(filename) {
      this.currentPdfFile = filename;
      this.showPdfDialog = true;
    },

    // Close video dialog
    closeVideoDialog() {
      this.showVideoDialog = false;
    },

    // Get education level color
    getEducationColor(level) {
      const colors = {
        ปริญญาตรี: "blue",
        ปริญญาโท: "purple",
        ปริญญาเอก: "orange darken-2"
      };
      return colors[level] || "grey";
    },

    // Show notification
    showNotification(type, text, icon) {
      const colors = {
        success: "success",
        error: "error",
        warning: "warning",
        info: "info"
      };
      this.snackbar = {
        show: true,
        color: colors[type] || "info",
        text,
        icon: icon || "mdi-information",
        timeout: 4000
      };
    }
  }
};
</script>

<style scoped>
/* Countdown Timer Styles */
.countdown-timer >>> .flip-countdown {
  font-family: "Roboto", sans-serif;
}

.countdown-timer >>> .flip-countdown__piece {
  background: #2c3e50;
  color: white;
  border-radius: 5px;
  font-size: 0.9rem;
  min-width: 35px;
  height: 35px;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.7rem;
  color: #666;
  margin-top: 5px;
}

/* Header Styles */
.header-card {
  overflow: hidden;
  border-radius: 12px !important;
}

.header-gradient {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%);
}

/* Info Cards */
.info-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.info-card-header {
  font-size: 1rem;
  font-weight: 600;
}

/* Status Card */
.status-card {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Main Form Card */
.main-form-card {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Branch Table */
.branch-table {
  border-radius: 8px !important;
}

.branch-table >>> .v-data-table-header {
  background-color: #f5f5f5;
}

.branch-table >>> .v-data-table-header th {
  font-weight: 600 !important;
  color: #424242 !important;
}

/* Empty State */
.empty-state {
  border: 2px dashed #e0e0e0 !important;
  border-radius: 12px !important;
  background-color: #fafafa;
}

/* Video Container */
.video-container {
  position: relative;
  width: 100%;
  background-color: #000;
}

/* Countdown Styles */
.countdown-alert {
  border-radius: 12px !important;
}

.countdown-box {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.countdown-box.info-box {
  background: rgba(33, 150, 243, 0.1);
}

.countdown-timer {
  font-family: "Roboto Mono", monospace;
}

.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 50px;
}

.countdown-value {
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 1;
  color: white;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.countdown-value.info-value {
  color: #1976d2;
}

.countdown-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  opacity: 0.9;
  margin-top: 4px;
}

/* Period Dates */
.period-dates {
  border: 1px solid #e0e0e0;
}

/* Branch Progress */
.branch-progress {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 8px;
}

/* Transitions */
.v-card {
  transition: all 0.3s ease;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .header-gradient .v-card-title {
    flex-direction: column;
    text-align: center;
  }

  .header-gradient .v-card-title .v-avatar {
    margin-right: 0 !important;
    margin-bottom: 16px;
  }

  .header-gradient .v-card-title .v-chip {
    margin-top: 16px;
  }

  .countdown-value {
    font-size: 1.4rem;
  }

  .countdown-item {
    min-width: 40px;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.conditions-transfer {
  animation: fadeIn 0.4s ease;
}

/* Urgent countdown animation */
.v-alert.error .countdown-value {
  animation: pulse 1s ease-in-out infinite;
}

/* Thai Font Support */
.conditions-transfer {
  font-family: "Sarabun", "Prompt", sans-serif;
}
</style>
